import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/components/layout/SetHreflang/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetailOverlay"] */ "/app/src/ui/components/pages/ProductDetail/product-chooser-wrapper/product-detail-overlay/product-detail-overlay.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductLandingPageContent"] */ "/app/src/ui/components/pages/ProductDetail/product-landing-page/product-landing-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Products"] */ "/app/src/ui/components/pages/products/products.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/components/tileRenderers/PageGridRenderer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalAreaLinkProvider"] */ "/app/src/ui/providers/externalAreaLinkProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductRulesProvider"] */ "/app/src/ui/providers/product-rules-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServerUserStateProvider"] */ "/app/src/ui/providers/server-user-state-provider.tsx");
